import * as t from "io-ts";
const nullable = (codec) => t.union([t.null, codec]);
export default nullable;
//# sourceMappingURL=nullable.js.map